/* eslint-disable */
import axios from "axios";
import config from "@assets/config.json"; // api 请求json
import { Message } from "view-design";
// 通用 Module
const state = {
  joinEx: null,
};
const mutations = {
  setJoinEx(state, data) {
    state.joinEx = data;
  },
};
const getters = {
  getJoinEx: (state) => {
    return state.joinEx;
  },
};
const actions = {
  // 获取公司默认参加几展会
  getDefaultJoinExhibition({ rootState }, id) {
    // （原手机不为空） 验证并更改手机
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/Join/DefaultJoin?compId=${id}`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          } else {
            resolve(null);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  // 绑定手机号相关

  // 1.原手机不为空
  changePhoneApply({ rootState }, opt) {
    // （原手机不为空） 验证并更改手机
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.auth}/api/account/ChangePhoneApply`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  changePhoneToken({ rootState }, opt) {
    // （原手机不为空） 新手机发送验证码
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.auth}/api/account/ChangePhoneToken`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            if (data.data.successed) {
              Message.success("验证码已发送");
            } else {
              Message.error("验证码发送失败");
            }
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  changePhoneOldToken({ rootState }, opt) {
    // （原手机不为空） 发送验证码
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.auth}/api/account/ChangePhoneOldToken`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            if (data.data.successed) {
              Message.success("验证码已发送");
            } else {
              Message.error("验证码发送失败");
            }
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  changePhoneOldCheck({ rootState }, opt) {
    // （原手机不为空） 验证手机验证码（省略）
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.auth}/api/account/ChangePhoneOldCheck`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  // 1.原手机不为空 end

  // 2.原手机为空
  bindPhoneToken({ rootState }, opt) {
    // （原手机为空） 发送验证码
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.auth}/api/account/BindPhoneToken`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            if (data.data.successed) {
              Message.success("验证码已发送");
            } else {
              Message.error("验证码发送失败");
            }
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  bindPhoneApply({ rootState }, opt) {
    // 验证并更改手机 绑定手机（原手机为空）
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.auth}/api/account/BindPhoneApply`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  // 2.原手机为空 end

  // 绑定手机号相关 end

  // 绑定邮箱号相关

  // 1.原邮箱不为空
  changeEmailApply({ rootState }, opt) {
    // （原邮箱不为空） 验证并更改邮箱
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.auth}/api/account/ChangeEmailApply`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  changeEmailToken({ rootState }, opt) {
    // （原邮箱不为空） 新邮箱发送验证码
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.auth}/api/account/ChangeEmailToken`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            if (data.data.successed) {
              Message.success("验证码已发送");
            } else {
              Message.error("验证码发送失败");
            }
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  changeEmailOldToken({ rootState }, opt) {
    // （原邮箱不为空） 发送验证码
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.auth}/api/account/ChangeEmailOldToken`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            if (data.data.successed) {
              Message.success("验证码已发送");
            } else {
              Message.error("验证码发送失败");
            }
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  changeEmailOldCheck({ rootState }, opt) {
    // （原邮箱不为空） 验证邮箱验证码（省略）
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.auth}/api/account/ChangeEmailOldCheck`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  // 1.原邮箱不为空 end

  // 2.原邮箱为空
  bindEmailToken({ rootState }, opt) {
    // （原邮箱为空） 发送验证码
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.auth}/api/account/BindEmailToken`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            if (data.data.successed) {
              Message.success("验证码已发送");
            } else {
              Message.error("验证码发送失败");
            }
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  bindEmailTokenCheck({ rootState }, opt) {
    // 验证邮箱
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.auth}/api/account/BindEmailTokenCheck`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          } else {
            resolve([]);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  bindEmailApply({ rootState }, opt) {
    // 验证并更改邮箱 绑定邮箱（原邮箱为空）
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.auth}/api/account/BindEmailApply`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  // 2.原邮箱为空 end

  // 绑定邮箱号相关 end

  // 1:品牌商—授权渠道,
  // 2:品牌商—招募地区,
  // 3:工厂—服务范围,
  // 4:工厂—代工类型,
  // 5:服务商—擅长领域,
  // 6:服务商—服务地区,
  // 7:加盟商—店铺类型,
  // 8:加盟商—招募地区,
  getActionType({ rootState }, type) {
    // 获取企业行为类型
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/actionType/GetList?typeId=${type}`,
          rootState.tokenHeaders
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          } else {
            resolve([]);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  // 1:品牌商—授权渠道,
  // 2:品牌商—招募地区,
  // 3:工厂—服务范围,
  // 4:工厂—代工类型,
  // 5:服务商—擅长领域,
  // 6:服务商—服务地区,
  // 7:加盟商—店铺类型,
  // 8:加盟商—招募地区,
  getActionTypeAndChild({ rootState }, type) {
    // 获取企业行为类型及子项目
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${
            config.api.reqApi
          }/api/actionType/GetListAndChildren?typeId=${type}`,
          rootState.tokenHeaders
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          } else {
            resolve([]);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },

  getCertificateById({ rootState }, id) {
    // 获取企业授权书
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/Certificate/?id=${id}`, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          } else {
            resolve([]);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  getCertificate({ rootState }, opt) {
    // 获取企业授权书
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/Certificate/GetAllByCompId`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          } else {
            resolve([]);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  setCertificateShow({ rootState }, option) {
    // 企业授权书屏蔽、显示
    return new Promise((resolve, reject) => {
      axios
        .put(
          `${config.api.reqApi}/api/Certificate/SetShow`,
          option,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  addCertificate({ rootState }, opt) {
    // 添加企业授权书
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/Certificate`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  editCertificate({ rootState }, opt) {
    // 修改企业授权书
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/Certificate`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  delCertificate({ rootState }, id) {
    // 删除企业授权书
    return new Promise((resolve, reject) => {
      axios
        .delete(
          `${config.api.reqApi}/api/Certificate?id=${id}`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  getCertificateTypeList({ rootState }) {
    // 获取资质证书名称列表
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/certificateType/GetList`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          } else {
            resolve([]);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },

  getCooperationById({ rootState }, id) {
    // 获取合作伙伴通过id
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/cooperation/?id=${id}`, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          } else {
            resolve([]);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  getCooperation({ rootState }, opt) {
    // 获取全部合作伙伴
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/cooperation/GetAllByCompId`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          } else {
            resolve([]);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  addCooperation({ rootState }, opt) {
    // 添加合作伙伴
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/cooperation`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  setCooperationShow({ rootState }, opt) {
    // 修改合作伙伴屏蔽、显示
    return new Promise((resolve, reject) => {
      axios
        .put(
          `${config.api.reqApi}/api/cooperation/SetShow`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  editCooperation({ rootState }, opt) {
    // 修改合作伙伴
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/cooperation`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  delCooperation({ rootState }, id) {
    // 删除合作伙伴
    return new Promise((resolve, reject) => {
      axios
        .delete(
          `${config.api.reqApi}/api/cooperation?id=${id}`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  addCompany({ rootState }, opt) {
    // 新增公司
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/company`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  editCompany({ rootState }, opt) {
    // 修改公司信息
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/company`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  editCompanyUpdate({ rootState }, opt) {
    // 无需审核就可修改的公司信息
    // 可修改字段（Logo、BusinessLicenses、Banner、AlbumId、Video、ShortNameEn、BusMode、Category、Properties、Extend、CreditCode、StyleId、ShareInfo、SunCode、SharePoster）
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/Company/update`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  editCompanyDown({ rootState }, opt) {
    // 修改公司信息 加入down表
    // "CommandId说明": "1：新增，2：修改，3：删除",
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/Company`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  editCompanyDownEdit({ rootState }, opt) {
    // 修改公司未审核的修改信息
    // "CommandId说明": "1：新增，2：修改，3：删除",
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/CompanyDown`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },

  getCompanyDownList({ rootState }, id) {
    // 获取公司提交记录
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/CompanyDown/GetRecord?joinId=${id}`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          } else {
            resolve(null);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },

  // 品牌设置相关
  getBrandById({ rootState }, id) {
    // 获取品牌设置通过id
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/brand/?id=${id}`, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  getBrand({ rootState }, option) {
    // 获取品牌设置
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/brand/GetAllByCompId`,
          option,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  setBrandShow({ rootState }, option) {
    // 品牌屏蔽、显示
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/brand/SetShow`, option, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  delBrand({ rootState }, id) {
    // 删除品牌设置
    return new Promise((resolve, reject) => {
      axios
        .delete(`${config.api.reqApi}/api/brand?id=${id}`, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  editBrand({ rootState }, opt) {
    // 修改品牌设置
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/brand`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  addBrand({ rootState }, opt) {
    // 添加品牌设置
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/brand`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },

  // 成功案例相关
  getExampleById({ rootState }, id) {
    // 获取成功案例通过id
    return new Promise((resolve, reject) => {
      axios
        .get(`${config.api.reqApi}/api/example/?id=${id}`, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  getExample({ rootState }, option) {
    // 获取成功案例
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/example/GetAllByCompId`,
          option,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  delExample({ rootState }, id) {
    // 删除成功案例
    return new Promise((resolve, reject) => {
      axios
        .delete(`${config.api.reqApi}/api/example?id=${id}`, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  editExample({ rootState }, opt) {
    // 修改成功案例
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/example`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  addExample({ rootState }, opt) {
    // 添加成功案例
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/example`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },

  // 公司id获取员工
  getStaffByCompId({ rootState }, id) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/staff/GetByCompId?compid=${id}`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  getStaffAllByCompId({ rootState }, id) {
    // 公司id获取全部员工
    return new Promise((resolve, reject) => {
      axios
        .get(
          `${config.api.reqApi}/api/staff/GetAllByCompId?compid=${id}`,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  delStaff({ rootState }, id) {
    // 删除人员
    return new Promise((resolve, reject) => {
      axios
        .delete(`${config.api.reqApi}/api/staff?id=${id}`, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  editStaff({ rootState }, opt) {
    // 修改人员
    return new Promise((resolve, reject) => {
      axios
        .put(`${config.api.reqApi}/api/staff`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  addStaff({ rootState }, opt) {
    // 添加人员
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/staff`, opt, rootState.header)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },

  // 公司id获取贸易配对
  getMatchesByCompId({ rootState }, opt) {
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/joinMatching/GetByCompany`,
          opt,
          rootState.header
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },

  getVerCode({ rootState }, opt) {
    // 找回密码 - 获取验证码
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/userinfo/ChangePasswordByPhoneToken`,
          opt
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },

  asyncVerCode({ rootState }, opt) {
    // 找回密码 - 验证验证码
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/userinfo/ValidatePhoneNumberToken`, opt)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },

  editVerCode({ rootState }, opt) {
    // 找回密码 - 重置新密码
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/userinfo/ResetPasswordByPhone`, opt)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },

  getInfoByUsername({ rootState }, opt) {
    // 根据用户名称获取手机号和密码等相关信息
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/UserInfo/ResetForgetPassword`, opt)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  SaveResetForgetPassword({ rootState }, opt) {
    // 根据用户名称获取手机号和密码等相关信息
    return new Promise((resolve, reject) => {
      axios
        .post(`${config.api.reqApi}/api/UserInfo/SaveResetForgetPassword`, opt)
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
  // 验证手机号和邮箱是否正确
  validatePhoneOrEmail({ rootState }, opt) {
    // 根据用户名称获取手机号和密码等相关信息
    return new Promise((resolve, reject) => {
      axios
        .post(
          `${config.api.reqApi}/api/UserInfo/ValidateUserNameAndPhoneEmail`,
          opt
        )
        .then((data) => {
          if (data.data) {
            resolve(data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    });
  },
};
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
